import React from 'react'
import styles from './header.jcss'
import Icon from 'blocks.simple/icon/icon'
import { colors } from 'theme'
import translate from 'core/translate'
import Checkbox from 'blocks.simple/checkbox/checkbox'

interface IHeader {
    selectedItemsLength: number
    deleteAllSelected: (value: boolean) => void
    onAdd: () => void
    selectOnly?: boolean
    selected: boolean
    clearSelection?: () => void
    selectAll?: () => void
}

export const Header = ({
    selectedItemsLength,
    deleteAllSelected,
    onAdd,
    selectOnly,
    selected,
    clearSelection,
    selectAll,
}: IHeader) => {
    return (
        <div className={styles.header}>
            <div className={styles.controlPositionBlock}>
                <div className={styles.controlBlock}>
                    {!selectOnly ? (
                        <>
                            <Icon
                                type={'plus'}
                                color={colors.blueAccent}
                                size={18}
                                className={styles.addIcon}
                                onClick={onAdd}
                            />
                            <Icon
                                type={'delete'}
                                color={colors.blueAccent}
                                disabled={!selectedItemsLength}
                                size={18}
                                onClick={() => deleteAllSelected(true)}
                            />
                        </>
                    ) : (
                        <div>
                            <div className={styles.checkbox}>
                                <Checkbox
                                    checked={selected}
                                    onClick={(value: any) => {
                                        if (value && selectAll) {
                                            selectAll()

                                            return
                                        }

                                        if (clearSelection) {
                                            clearSelection()
                                        }
                                    }}
                                    label={translate(!selected ? 'selectAll' : 'deselect')}
                                    labelClassName={styles.checkboxLabel}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
